var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "b-card",
        [
          _c(
            "b-card-body",
            [
              _c(
                "b-row",
                { staticClass: "justify-content-between" },
                [
                  _c(
                    "b-col",
                    { staticClass: "my-1", attrs: { md: "2", sm: "4" } },
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "mb-0" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "d-inline-block text-sm-left mr-50",
                            },
                            [_vm._v("Per page")]
                          ),
                          _c("b-form-select", {
                            staticClass: "w-50",
                            attrs: {
                              id: "perPageSelect",
                              size: "sm",
                              options: _vm.pageOptions,
                            },
                            model: {
                              value: _vm.perPage,
                              callback: function ($$v) {
                                _vm.perPage = $$v
                              },
                              expression: "perPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { staticClass: "my-1", attrs: { md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-0",
                          attrs: {
                            label: "Filter",
                            "label-cols-sm": "3",
                            "label-align-sm": "right",
                            "label-size": "sm",
                            "label-for": "filterInput",
                          },
                        },
                        [
                          _c(
                            "b-input-group",
                            { attrs: { size: "sm" } },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "filterInput",
                                  type: "search",
                                  placeholder: "Type to Search",
                                },
                                model: {
                                  value: _vm.filter,
                                  callback: function ($$v) {
                                    _vm.filter = $$v
                                  },
                                  expression: "filter",
                                },
                              }),
                              _c(
                                "b-input-group-append",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { disabled: !_vm.filter },
                                      on: {
                                        click: function ($event) {
                                          _vm.filter = ""
                                        },
                                      },
                                    },
                                    [_vm._v(" Clear ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          responsive: "",
                          "per-page": _vm.perPage,
                          "current-page": _vm.currentPage,
                          items: _vm.filteredTimesheet,
                          fields: _vm.approved_timesheet_fields,
                          "sort-by": _vm.sortBy,
                          "sort-desc": _vm.sortDesc,
                          "sort-direction": _vm.sortDirection,
                          filter: _vm.filter,
                          "filter-included-fields": _vm.filterOn,
                        },
                        on: {
                          "update:sortBy": function ($event) {
                            _vm.sortBy = $event
                          },
                          "update:sort-by": function ($event) {
                            _vm.sortBy = $event
                          },
                          "update:sortDesc": function ($event) {
                            _vm.sortDesc = $event
                          },
                          "update:sort-desc": function ($event) {
                            _vm.sortDesc = $event
                          },
                          filtered: _vm.onFiltered,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "cell(status)",
                            fn: function (data) {
                              return [
                                _c(
                                  "b-badge",
                                  {
                                    attrs: {
                                      variant: _vm.getStatusVariant(
                                        data.item.status
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          data.item.status
                                            .charAt(0)
                                            .toUpperCase() +
                                            data.item.status
                                              .toLowerCase()
                                              .slice(1)
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(employee)",
                            fn: function (data) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getEmployee(data.item.employeeID)
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(comment)",
                            fn: function (data) {
                              return [
                                _vm._v(
                                  " " + _vm._s(data.item.taskDescription) + " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(totalHours)",
                            fn: function (data) {
                              return [
                                _vm._v(
                                  " " + _vm._s(data.item.hoursWorked) + " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(month)",
                            fn: function (data) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.formatMonth(data.item.date)) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(submittedOn)",
                            fn: function (data) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.formatDate(data.item.date)) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(startDate)",
                            fn: function (data) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      data.item.startDate
                                        ? _vm.formatDate(data.item.startDate)
                                        : "-"
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(endDate)",
                            fn: function (data) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      data.item.endDate
                                        ? _vm.formatDate(data.item.endDate)
                                        : "-"
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(actions)",
                            fn: function (data) {
                              return [
                                _c(
                                  "b-dropdown",
                                  {
                                    staticClass: "m-1",
                                    attrs: {
                                      variant: "link",
                                      "toggle-class": "p-0",
                                      "no-caret": "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "button-content",
                                          fn: function () {
                                            return [
                                              _c("feather-icon", {
                                                staticClass:
                                                  "align-middle text-body",
                                                attrs: {
                                                  icon: "MoreVerticalIcon",
                                                  size: "16",
                                                },
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.timesheetAction(
                                              "DONE",
                                              data.item.id
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "CheckIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-50" },
                                          [_vm._v("Done")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.viewTimesheet(data.item)
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "EyeIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-50" },
                                          [_vm._v("View")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c(
                        "b-modal",
                        {
                          ref: "modalviewTimesheet",
                          attrs: {
                            id: "modal-view-approved-timesheet",
                            "ok-only": "",
                            "ok-title": "View",
                            centered: "",
                            size: "lg",
                            title: "View Approved timesheet",
                            "hide-footer": true,
                          },
                        },
                        [
                          _c(
                            "b-form",
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "12" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label: "Date",
                                            "label-for": "date",
                                          },
                                        },
                                        [
                                          _c("b-form-datepicker", {
                                            attrs: {
                                              id: "date",
                                              placeholder: "Date",
                                              disabled: "",
                                            },
                                            model: {
                                              value: _vm.timesheetId.date,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.timesheetId,
                                                  "date",
                                                  $$v
                                                )
                                              },
                                              expression: "timesheetId.date",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "12" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label: "Project",
                                            "label-for": "project",
                                          },
                                        },
                                        [
                                          _c("b-form-select", {
                                            attrs: {
                                              options: _vm.projectOptions,
                                              disabled: "",
                                            },
                                            model: {
                                              value: _vm.timesheetId.projectID,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.timesheetId,
                                                  "projectID",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "timesheetId.projectID",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "12" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label: "Employee",
                                            "label-for": "employee",
                                          },
                                        },
                                        [
                                          _c("b-form-select", {
                                            attrs: {
                                              options: _vm.employeeOptions,
                                              disabled: "",
                                            },
                                            model: {
                                              value: _vm.timesheetId.employeeID,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.timesheetId,
                                                  "employeeID",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "timesheetId.employeeID",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label: "Total Hours",
                                            "label-for": "totalHours",
                                          },
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              name: "totalHours",
                                              placeholder: "Total Hours",
                                              readonly: "",
                                            },
                                            model: {
                                              value:
                                                _vm.timesheetId.hoursWorked,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.timesheetId,
                                                  "hoursWorked",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "timesheetId.hoursWorked",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label: "Description",
                                            "label-for": "description",
                                          },
                                        },
                                        [
                                          _c("b-form-textarea", {
                                            attrs: {
                                              name: "description",
                                              placeholder: "Description",
                                              readonly: "",
                                            },
                                            model: {
                                              value:
                                                _vm.timesheetId.taskDescription,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.timesheetId,
                                                  "taskDescription",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "timesheetId.taskDescription",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-pagination", {
                        staticClass: "my-0",
                        attrs: {
                          "total-rows": _vm.totalRows,
                          "per-page": _vm.perPage,
                          align: "center",
                          size: "sm",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }